import styled from 'styled-components';
import { alphabetColors } from '../../../../shared/constants';
import { RATING_TYPES, RatingType } from './constants';

export const ViewContactContainer = styled.div`
  display: flex;
  padding: 0;
  height: 100%;
`;

export const SummaryPane = styled.div`
  display: flex;
  flex-direction: column;
  width: 410px;
  background: #ffffff;
  box-shadow: 4px -3px 6px 1px #ebeff3a8;
  z-index: 9;
  div.details-table {
    flex: 1;
    overflow: auto;
    border-bottom: 1px solid #ececec;
  }
`;

export const ContactCard = styled.div<{ alphabet?: string }>`
  display: flex;
  border-bottom: 1px solid #ececec;
  div.avatar {
    border-radius: 4px;
    background: ${({ alphabet }) =>
      alphabetColors[`${alphabet || ''}`.toLowerCase()] || alphabetColors.a};
    border: 1px solid
      ${({ alphabet }) =>
        alphabetColors[`${alphabet || ''}`.toLowerCase()] || alphabetColors.a};
    box-sizing: border-box;
    margin: 32px 28px;
    width: 50px;
    height: 50px;
    font-size: 24px;
    color: #ffffff;
    display: grid;
    place-content: center;
    font-weight: bold;
  }
  div.details {
    flex: 1;
    margin: auto 0;
    overflow: hidden;
    .overflow {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    div.name {
      font-weight: 600;
      font-size: 20px;
      color: #12344d;
    }
    div.email {
      font-size: 13px;
      color: #12344d;
    }
  }
  div.edit-button {
    display: flex;
    align-items: center;
    button {
      display: flex;
      align-items: center;
      & > :not(:last-child) {
        margin-right: 8px;
      }
    }
    margin: 0 24px;
  }
`;

export const ContactDetailsTable = styled.table`
  width: 100%;
  border-spacing: 24px;
  td.key {
    font-size: 14px;
    color: var(--color-smoke-700);
  }
  td.value {
    font-weight: 600;
    font-size: 14px;
    color: var(--color-elephant-900);
    word-break: break-all;
  }
`;

export const ListDetailsContainer = styled.div<{ pd?: string }>`
  padding: ${({ pd }) => pd || '24px'};
  div.header {
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    color: #000000;
    opacity: 0.54;
    margin-bottom: 16px;
  }
  div.list {
    display: flex;
    flex-wrap: wrap;
    div.item {
      cursor: pointer;
      margin: 0 12px 12px 0;
      font-weight: 500;
      font-size: 12px;
      color: #000000;
      padding: 8px 12px;
      background: #ffffff;
      border: 1px solid #ededed;
      border-radius: 23px;
      width: fit-content;
    }
  }
`;

export const DetailsPane = styled.div`
  flex: 1;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  div.contact-details-container {
    flex: 1;
    overflow: auto;
  }
`;

export const TabContent = styled.div``;

export const ContactFields = styled.div`
  padding: 48px;
  display: flex;
  flex-wrap: wrap;
  div.field {
    width: 300px;
    margin: 0 48px 32px 0;
    div.label {
      font-size: 14px;
      color: var(--color-smoke-700);
      margin-bottom: 8px;
    }
    div.value {
      word-break: break-all;
      font-weight: 600;
      font-size: 14px;
      color: var(--color-elephant-900);
    }
  }
`;

export const ResponseContainer = styled.div`
  height: 100%;
  overflow: auto;
  div.response-filters {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 24px;
    background: #fff;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #12344d;
    display: flex;
    align-items: center;
    div.filter {
      padding: 8px;
      cursor: pointer;
      & > :not(:last-child) {
        margin-right: 16px;
      }
      :not(:last-child) {
        margin-right: 16px;
      }
    }
  }
`;

export const RatingAvatar = styled.div<{ ratingType: RatingType }>`
  background: ${({ ratingType }) => RATING_TYPES[ratingType].bg};
  border: 1px solid ${({ ratingType }) => RATING_TYPES[ratingType].border};
  border-radius: 4px;
  width: 46px;
  height: 46px;
  font-size: 18px;
  color: ${({ ratingType }) => RATING_TYPES[ratingType].color};
  display: grid;
  place-content: center;
  font-weight: bold;
`;

export const TimelineCard = styled.div`
  padding: 0px 24px 24px 24px;
  :not(:last-child) {
    margin-bottom: 16px;
  }
  display: flex;
  div.timeline {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 32px;
    margin-right: 8px;
    padding-top: 8px;
    div.line {
      width: 1px;
      flex: 1;
      border: 1px dashed #f1f1f1;
    }
    & > :not(:last-child) {
      margin-bottom: 8px;
    }
  }
  div.response-info {
    flex: 1;
    .content {
      padding: 0px 16px;
    }
    .question {
      margin-top: 0;
    }
    div.time-info {
      font-weight: 700;
      font-size: 14px;
      line-height: 30px;
      color: #000000;
      opacity: 0.6;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      span.channel {
        font-weight: 500;
        font-size: 13px;
        color: #000000;
        opacity: 0.6;
      }
      div.divider {
        border: 1px solid #888888;
        width: 1px;
        height: 8px;
      }
      span.survey-name {
        font-style: italic;
        font-weight: 500;
        font-size: 13px;
        color: #000000;
        opacity: 0.6;
      }
      & > :not(:last-child) {
        margin-right: 8px;
      }
    }
  }
`;

export const ResponseCardContainer = styled.div<{ isPages?: boolean }>`
  padding: 16px;
  background: ${({ isPages }) => (isPages ? '#f4f7f9' : 'var(--color-milk)')};
  border: 1px solid #e6e6e6;
  box-shadow: 0px 2px 4px rgba(18, 52, 77, 0.06);
  border-radius: 8px;
  flex: 1;
  display: flex;
  div.response-loading {
    padding: 0 16px;
    flex: 1;
  }
  div.response-list {
    flex: 1;
    div.favorite {
      height: 34px;
      padding: 8px;
      display: flex;
      div.spacer {
        flex: 1;
      }
      svg {
        cursor: pointer;
      }
    }
    span.deleted-text {
      font-size: 12px;
      background-color: var(--color-smoke-50);
      margin-left: 10px;
      padding: 5px 15px;
      border-radius: 5px;
      color: rgb(56, 69, 81);
      font-weight: 600;
    }
    div.responses {
      padding: 0 16px;
      div.ques {
        font-weight: 400;
        font-size: 12px;
        color: #000000;
        opacity: 0.6;
        margin-bottom: 8px;
      }
      div.more {
        color: #264966;
        cursor: pointer;
        font-size: 12px;
        margin-bottom: 8px;
        padding-bottom: 10px;
        border-bottom: 1px solid #ebeff3;
      }
      div.view-all {
        display: flex;
        align-items: center;
        gap: 6px;
        font-weight: 400;
        font-size: 12px;
        line-height: 30px;
        color: #006cc2;
        width: fit-content;
        cursor: pointer;
      }
      div.ans {
        font-size: 14px;
        color: var(--base-color);
        font-weight: 600;
        line-height: 30px;
        text-align: justify;
        margin-bottom: 24px;
      }
    }
  }
  div.response {
    font-size: 14px;
    color: var(--base-color);
    font-weight: 600;
    line-height: 30px;
    overflow-wrap: break-word;
  }
  div.pages-card {
    background: var(--color-milk);
    margin: 16px 0px;
    border-radius: 8px;
    padding: 16px 16px 1px 16px;
    .page-name-desc-container {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-bottom: 16px;
      .page-name {
        font-weight: 600;
        padding: 6px 8px;
        border-radius: 4px;
        display: flex;
        width: fit-content;
        white-space: nowrap;
        line-height: 1;
        font-size: 12px;
        background-color: #e5f2fd;
        color: #2c5cc5;
      }
    }
  }
`;
